import { render } from "./AuthorizationError.vue?vue&type=template&id=28b1cdf8"
import script from "./AuthorizationError.vue?vue&type=script&lang=js"
export * from "./AuthorizationError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__